import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "Serverless Chrome on AWS Lambda, the guide that works in 2019 and beyond",
  "description": "",
  "published": "2019-04-11T00:00:00.000Z",
  "redirect_from": ["/blog/serverless-chrome-on-aws-lambda-the-guide-works-in-2019-beyond/swizec/9024"],
  "categories": "Back End, Technical",
  "hero": "./img/techletter.app-screenshot-1555000348960.png",
  "content_upgrade": "ServerlessHandbook"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Getting Chrome and Puppeteer to work on AWS Lambda is ... tricky. There's many guides, many blogs out there and they're all broken in subtle little ways you won't realize until it's too late.`}</p>
    <p>{`Outdated versions of Chrome, build packages too big for an AWS Lambda, or silently breaking with an infinite timeout. When you end up trawling through old Github issues looking for clues you know something's wrong.`}</p>
    <p>{`That was me.`}</p>
    <p><a parentName="p" {...{
        "href": "https://84wz7ux5rc.execute-api.us-east-1.amazonaws.com/default/screenshot-as-a-service-dev-screenshot-function?url=https://twitter.com/Swizec/status/1115300975349121028"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "71.74887892376681%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'286\\'%20viewBox=\\'0%200%20400%20286\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2020c-2%201-7%207-8%2010l2%2011%201%201c0%204%2012%208%2017%206s7-5%204-5c-4%200-5-3-2-5l3-1%203-2c2-2%202-2%201-6-2-8-13-12-21-9m30%20129c0%206%200%206%203%206%204%200%207-3%207-6%200-5-2-7-7-7h-3v7m46%2087c-3%204-3%208%201%2011%207%206%2016-4%2010-11l-5-2-6%202m39-1c-3%201-5%204-3%205%202%200%202%201%202%203-2%206%205%208%209%204%205-5-1-15-8-12\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/81c219d759ac679d9a0e6316832eb148/ca0a1/techletter.app-screenshot-1555000348960.webp 223w", "/static/81c219d759ac679d9a0e6316832eb148/75680/techletter.app-screenshot-1555000348960.webp 445w", "/static/81c219d759ac679d9a0e6316832eb148/0ba47/techletter.app-screenshot-1555000348960.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/81c219d759ac679d9a0e6316832eb148/e92b6/techletter.app-screenshot-1555000348960.png 223w", "/static/81c219d759ac679d9a0e6316832eb148/e66bf/techletter.app-screenshot-1555000348960.png 445w", "/static/81c219d759ac679d9a0e6316832eb148/6af66/techletter.app-screenshot-1555000348960.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/81c219d759ac679d9a0e6316832eb148/6af66/techletter.app-screenshot-1555000348960.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I'm writing this guide as a love letter to my future self. Never again will I fall into this trap. Maybe it helps you too :)`}</p>
    <ContentUpgrades.ServerlessHandbook />
    <h2 {...{
      "id": "the-objective"
    }}>{`The objective`}</h2>
    <p>{`We're building a serverless screenshot service. It's the TODOapp of the headless serverless Chrome world. Every other guide uses this example :D`}</p>
    <p>{`You can see my `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lambda-screenshot-as-a-service"
      }}>{`final repo on Github`}</a>{`. Disregard the README. A long time ago I used a starter kit that no longer works. Chrome version too old, hangs on `}<inlineCode parentName="p">{`newPage`}</inlineCode>{`.`}</p>
    <p>{`We'll take screenshots of Instagram posts. Convenient for embedding in emails. You could use a similar setup for testing or to make social sharing thumbnails. Whatever your heart desires.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/6052f/FBZeWxj.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.91031390134529%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'159\\'%20viewBox=\\'0%200%20400%20159\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M206%2018v9l1%206c0-2%202-3%206-1l2%201h-2c-2%200-2%200%200%201l4%201c0-1%203%200%205%202l4%203-2%201c-2%201-3%202-3%204%200%203-1%203-9%202h-6l3%201c5%200%2010%201%209%203s4%200%205-3c1-2%205-3%204%200h2l1-2%201-1%201%201c1%201%206%200%207-1h1l3%201c8%200%2015%206%2021%2018%205%2010%205%2011%203%2011s-3%201-4%204l-3%204%201-5c2-3%202-6%202-10-1-6-3-10-4-8s-5%206-7%206l-1%201-1%203c-1%202-1%202-3%200l-2-1-3-1-3-3%201-2%202-1%202-1-1-1c-3%201-2%200%200-3l3-2-1%202c-2%202-2%202%200%202h2l2-3c1-2%201-2-1-2l-3-1-1-1c-1-1-1-1%201-2l3-1-3-1c-14-3-27%208-27%2023%200%203%200%205%201%204%200-2%202-3%202-1h2l1%201c0%202%201%202%203%200h1l3-1c1-3%202-3%203-2l4%201%202%201c-1%201%204%203%205%202l2-1-1%202v3l2%202%201%203%201%202c0%202%201%202%203%202%203%200-2%203-6%204-12%203-26-4-30-16-2-4-1-12%202-18a1622%201622%200%20000-4c-2%202-2%202-3%201%200-2-2%200-6%205l-4%208c0%201%201%201%205-5%203-4%204-5%204-3%201%202-3%208-5%208l-3%203c-1%202-2%206-2%2034v32h44v-4c0-3%200-3%201-2h1c-1-2%201-5%202-5v7h-2v2l-1%201%2039%201h38v-14l-1-15V89h-3c-2%200-3%200-5-2-1-4-2-10%200-10l1-1c0-1%201-2%203-1%202%200%202%201%201%204l1%204c2%200%202-1%202-6s0-6-2-6l-2%201-1%201v-8l2-2c4%200%203-5%200-6-2%200-3-1-3-2l-2-3%201-1c1%201%202%200%202-1h1l2%201%201%201c1%201%201-7%201-17V17h-60l-60%201m92%2039l-3%201c-2%200-7%207-7%208v3c-1%202%201%204%205%205%201%201%202%200%202-1%201-2%201-2%202-1h6c6%200%207%200%2010%202%204%203%204%202%203-2l-1-6c0-7-10-13-17-9m-28%2023l-2%202-2%203c0%205%200%206-1%203-2-1-2-1-3%203l-2%206-1%202%203-2c1-3%201-3%203-1%201%202%201%201%203-6v-4l1%202v4c-1%201-1%201%201%201%202%201%202%202%201%202l-4%204-3%205c-1%201-1%203%201%203%201%200%202%207%200%207-3%201-8%2010-7%2013%202%203%202%203%205-1l3-3v-3l2-1c0-2%2015-16%2016-16l1-1-5-3c-6-1-8-3-5-4l2-1%202-2v-3l-1-4c0-4-1-5-3-3%200%202-1%202-1%201l-2-3-2-2v2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6ed61ecd76d6da120bf1b35f2de2c6f8/ca0a1/FBZeWxj.webp 223w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/75680/FBZeWxj.webp 445w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/8d1ba/FBZeWxj.webp 890w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/3838e/FBZeWxj.webp 1335w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/e11e5/FBZeWxj.webp 1780w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/9bf61/FBZeWxj.webp 2030w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6ed61ecd76d6da120bf1b35f2de2c6f8/e92b6/FBZeWxj.png 223w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/e66bf/FBZeWxj.png 445w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/4ef49/FBZeWxj.png 890w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/4e814/FBZeWxj.png 1335w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/701e9/FBZeWxj.png 1780w", "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/6052f/FBZeWxj.png 2030w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/6ed61ecd76d6da120bf1b35f2de2c6f8/4ef49/FBZeWxj.png",
              "alt": "FBZeWxj",
              "title": "FBZeWxj",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`I built my screenshot Lambda for `}<a parentName="p" {...{
        "href": "https://techletter.app/"
      }}>{`TechLetterApp`}</a>{`. A tool that converts markdown into newsletters.`}</p>
    <p>{`You will learn about:`}</p>
    <ul>
      <li parentName="ul">{`serverless`}</li>
      <li parentName="ul">{`AWS Lambdas`}</li>
      <li parentName="ul">{`headless Chrome`}</li>
      <li parentName="ul">{`Chrome Puppeteer`}</li>
      <li parentName="ul">{`uploading to S3`}</li>
    </ul>
    <p>{`Our Lambda is going to take an Instagram URL, take a screenshot, upload the file to S3, and return the URL.`}</p>
    <h2 {...{
      "id": "init-new-project"
    }}>{`Init new project`}</h2>
    <p>{`Start a new project. We're going raw, no init scripts. Don't need 😇`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%24%20mkdir%20screenshot-lambda%0A%24%20cd%20screenshot-lambda%0A%24%20yarn%2Fnpm%20init"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "302px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "73.99103139013454%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'295\\'%20viewBox=\\'0%200%20400%20295\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M45%2066l-2%203v161l3%202%202%202h305l2-2%203-2V68l-2-2-3-2H47l-2%202m47%2021c-4%205-1%2013%205%2013%203%200%208-5%208-8%200-7-9-10-13-5m29-2c-5%202-6%207-3%2011%205%207%2015%201%2012-7%200-2-5-5-6-5l-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/25370c0684b924506a9a7b09a63e468b/ca0a1/techletter.app-screenshot-1555000349452.webp 223w", "/static/25370c0684b924506a9a7b09a63e468b/7cc02/techletter.app-screenshot-1555000349452.webp 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/25370c0684b924506a9a7b09a63e468b/e92b6/techletter.app-screenshot-1555000349452.png 223w", "/static/25370c0684b924506a9a7b09a63e468b/5f1d2/techletter.app-screenshot-1555000349452.png 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/25370c0684b924506a9a7b09a63e468b/5f1d2/techletter.app-screenshot-1555000349452.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Yarn or npm will ask you a bunch of questions about your new project. Answer them and you'll end up with a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
    <p>{`This is also a great opportunity to run `}<inlineCode parentName="p">{`git init`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "s3-bucket"
    }}>{`S3 bucket`}</h2>
    <p>{`Before we begin, you'll need an S3 bucket as well. There is surely a way to create these via Serverless, but I don't know it.`}</p>
    <p>{`Go into your AWS console, search for S3, create a new bucket and give it a name.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6a8d2c403ef309ed6db41b7696a35b52/769f8/zvF6SZ3.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.16143497757847%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'272\\'%20viewBox=\\'0%200%20400%20272\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2010v11h79v20h321v-3l-2-6-1-2%201%201h1l2-16c0-9%200-15-1-14S105%202%2031%200H0v10m109%2091v8h55V95l-28-1h-27v7m101%2055h-8c-5%200-7%201-7%202l4%201%203-1h9l9%201h9l3-1h4l2%201v1l1-2-3-1-3-1-1-1-7%201h-4l-2%201h-1l-3-1h-5m20%2061h-8c-5%200-7%201-7%202l4%201%203-1h9l9%201h20l1-1h3l3%201%202-1-8-1-8-1h-1l-3%201-4-1h-4l-2%201h-1l-3-1h-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6a8d2c403ef309ed6db41b7696a35b52/ca0a1/zvF6SZ3.webp 223w", "/static/6a8d2c403ef309ed6db41b7696a35b52/75680/zvF6SZ3.webp 445w", "/static/6a8d2c403ef309ed6db41b7696a35b52/8d1ba/zvF6SZ3.webp 890w", "/static/6a8d2c403ef309ed6db41b7696a35b52/3838e/zvF6SZ3.webp 1335w", "/static/6a8d2c403ef309ed6db41b7696a35b52/e11e5/zvF6SZ3.webp 1780w", "/static/6a8d2c403ef309ed6db41b7696a35b52/7e82b/zvF6SZ3.webp 1924w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6a8d2c403ef309ed6db41b7696a35b52/e92b6/zvF6SZ3.png 223w", "/static/6a8d2c403ef309ed6db41b7696a35b52/e66bf/zvF6SZ3.png 445w", "/static/6a8d2c403ef309ed6db41b7696a35b52/4ef49/zvF6SZ3.png 890w", "/static/6a8d2c403ef309ed6db41b7696a35b52/4e814/zvF6SZ3.png 1335w", "/static/6a8d2c403ef309ed6db41b7696a35b52/701e9/zvF6SZ3.png 1780w", "/static/6a8d2c403ef309ed6db41b7696a35b52/769f8/zvF6SZ3.png 1924w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/6a8d2c403ef309ed6db41b7696a35b52/4ef49/zvF6SZ3.png",
              "alt": "zvF6SZ3",
              "title": "zvF6SZ3",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "serverlessyml"
    }}>{`Serverless.yml`}</h2>
    <p>{`We start our project with serverless.yml – the Serverless configuration file. Handles all our AWS setup so we can avoid Amazon's confusing dashboard and avoid clicking around. Also means your configuration and server setup becomes part of your code so it's repeatable and always the same.`}</p>
    <p>{`Version controlled too 👌`}</p>
    <p>{`I'm assuming you already have Serverless and have `}<a parentName="p" {...{
        "href": "https://serverless.com/framework/docs/providers/aws/guide/installation/"
      }}>{`set up your AWS credentials`}</a>{`.`}</p>
    <p>{`Create a `}<inlineCode parentName="p">{`serverless.yml`}</inlineCode>{` file and add this stuff 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=yaml&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=service%3A%20screenshot-lambda%0A%0Aprovider%3A%0A%20%20%20%20name%3A%20aws%0A%20%20%20%20runtime%3A%20nodejs8.10%0A%20%20%20%20memorySize%3A%202536%0A%20%20%20%20timeout%3A%20180%0A%20%20%20%20iamRoleStatements%3A%0A%20%20%20%20%20%20%20%20-%20Effect%3A%20%22Allow%22%0A%20%20%20%20%20%20%20%20%20%20Action%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20-%20%22s3%3Aupload%22%0A%20%20%20%20%20%20%20%20%20%20Resource%3A%20%22arn%3Aaws%3As3%3A%3A%3A%3Cyour%20s3%20bucket%3E%2F*%22%0A%0Afunctions%3A%0A%20%20%20%20screenshot-function%3A%0A%20%20%20%20%20%20%20%20handler%3A%20src%2Findex.handler%0A%20%20%20%20%20%20%20%20environment%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20DEBUG%3A%200%0A%0Apackage%3A%0A%20%20%20%20exclude%3A%0A%20%20%20%20%20%20%20%20-%20node_modules%2Fpuppeteer%2F.local-chromium%2F**%0A%0Aplugins%3A%0A%20%20%20%20-%20serverless-plugin-chrome%0A%0Acustom%3A%0A%20%20%20%20chrome%3A%0A%20%20%20%20%20%20%20%20flags%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20--window-size%3D1280%2C1696%20%23%20Letter%20size%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20--hide-scrollbars%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20--ignore-certificate-errors%0A%20%20%20%20%20%20%20%20functions%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20screenshot-function"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "526px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "148.4304932735426%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'594\\'%20viewBox=\\'0%200%20400%20594\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2038c-2%202-1%20517%201%20519s346%202%20348%200%203-517%201-519-348-2-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cf34052dbf814940835441cc79918b33/ca0a1/techletter.app-screenshot-1555000349449.webp 223w", "/static/cf34052dbf814940835441cc79918b33/75680/techletter.app-screenshot-1555000349449.webp 445w", "/static/cf34052dbf814940835441cc79918b33/9752a/techletter.app-screenshot-1555000349449.webp 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cf34052dbf814940835441cc79918b33/e92b6/techletter.app-screenshot-1555000349449.png 223w", "/static/cf34052dbf814940835441cc79918b33/e66bf/techletter.app-screenshot-1555000349449.png 445w", "/static/cf34052dbf814940835441cc79918b33/2d7ab/techletter.app-screenshot-1555000349449.png 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cf34052dbf814940835441cc79918b33/2d7ab/techletter.app-screenshot-1555000349449.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Here's what it means`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`service`}</strong>{` gives your service a name. Used when constructing endpoints for your Lambdas and such`}</li>
      <li parentName="ul"><strong parentName="li">{`provider`}</strong>{` tells Serverless that we're using AWS and sets some basic config. Which `}<inlineCode parentName="li">{`node`}</inlineCode>{` version we're using, how much memory we want for Lambdas, the default timeout.`}</li>
      <li parentName="ul"><strong parentName="li">{`provider/iamRoleStatements`}</strong>{` configures permissions for our service. Our service needs upload access to S3. Permissions are the most common source of weird bugs and failures in my experience. Best copy from somewhere else :)`}</li>
      <li parentName="ul"><strong parentName="li">{`functions`}</strong>{` specifies our Lambda functions. We have a `}<inlineCode parentName="li">{`screenshot-function`}</inlineCode>{` handled by the `}<inlineCode parentName="li">{`handler`}</inlineCode>{` method in `}<inlineCode parentName="li">{`src/index.js`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`package`}</strong>{` specifies service packaging instructions. We're telling Serverless to exclude the local Chromium build just in case it's there.`}</li>
      <li parentName="ul"><strong parentName="li">{`plugins`}</strong>{` Serverless comes with a rich ecosystem of plugins. This is where we specify them. We need `}<inlineCode parentName="li">{`serverless-plugin-chrome`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`custom`}</strong>{` lets us add a bunch of configuration. Usually for our plugins. Here we specify some runtime flags for Chrome and tell `}<inlineCode parentName="li">{`serverless-plugin-chrome`}</inlineCode>{` to make Chrome available to the `}<inlineCode parentName="li">{`screenshot-function`}</inlineCode>{` Lambda`}</li>
    </ul>
    <p>{`Other guides will show you different ways of running Chrome. Those are outdated and bad. This is the best approach.`}</p>
    <p>{`Using `}<inlineCode parentName="p">{`serverless-plugin-chrome`}</inlineCode>{` means you're running a remote cloud version of Chrome instead of packaging the entire binary into your Lambda. Makes deploys faster, the Lambda smaller, and your costs lower. I think.`}</p>
    <p>{`Don't quote me on the costs 😅`}</p>
    <h2 {...{
      "id": "install-dependencies"
    }}>{`Install dependencies`}</h2>
    <p>{`Next we need to install some libraries.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%24%20yarn%20add%20%40serverless-chrome%2Flambda%20gm%20puppeteer-core%20superagent%20aws-sdk%20url%0A%24%20yarn%20add%20--dev%20serverless-plugin-chrome"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "718px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "28.699551569506728%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'114\\'%20viewBox=\\'0%200%20400%20114\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2028v31l1%2029h363V28l-182-1-182%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2e06b3c66c341adcecfe2e9acb388812/ca0a1/techletter.app-screenshot-1555000349464.webp 223w", "/static/2e06b3c66c341adcecfe2e9acb388812/75680/techletter.app-screenshot-1555000349464.webp 445w", "/static/2e06b3c66c341adcecfe2e9acb388812/7d0c9/techletter.app-screenshot-1555000349464.webp 718w"],
                "sizes": "(max-width: 718px) 100vw, 718px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2e06b3c66c341adcecfe2e9acb388812/e92b6/techletter.app-screenshot-1555000349464.png 223w", "/static/2e06b3c66c341adcecfe2e9acb388812/e66bf/techletter.app-screenshot-1555000349464.png 445w", "/static/2e06b3c66c341adcecfe2e9acb388812/57dc1/techletter.app-screenshot-1555000349464.png 718w"],
                "sizes": "(max-width: 718px) 100vw, 718px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2e06b3c66c341adcecfe2e9acb388812/57dc1/techletter.app-screenshot-1555000349464.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><strong parentName="p">{`@serverless-chrome/lambda`}</strong>{` will let us talk to Chrome `}<strong parentName="p">{`gm`}</strong>{` is ImageMagick, we'll use it to resize and optimize images for size `}<strong parentName="p">{`puppeteer-core`}</strong>{` is a minimal version of Puppeteer so we can drive Chrome with JavaScript `}<strong parentName="p">{`superagent`}</strong>{` is a JavaScript library for making requests. We're using it because I copied that part of the code from `}<a parentName="p" {...{
        "href": "https://nadeesha.github.io/headless-chrome-puppeteer-lambda-servelerless/"
      }}>{`another guide`}</a>{` `}<strong parentName="p">{`aws-sdk`}</strong>{` has a bunch of utilities for talking to AWS. In our case for S3 uploads. `}<strong parentName="p">{`url`}</strong>{` will make it easier for us to parse URLs `}<strong parentName="p">{`serverless-plugin-chrome`}</strong>{` handles all the Chrome stuff for us. We don't have to care 👌`}</p>
    <h2 {...{
      "id": "handlerjs"
    }}>{`handler.js`}</h2>
    <p>{`Our `}<inlineCode parentName="p">{`handler.js`}</inlineCode>{` file takes care of one thing: Accepting an HTTP request, setting CORS headers, initiating Chrome stuff, calling our code, and responding with an HTTP response.`}</p>
    <p>{`Looks like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20getChrome%20%3D%20require(%22.%2FgetChrome%22)%3B%0Aconst%20puppeteer%20%3D%20require(%22puppeteer-core%22)%3B%0A%0Aconst%20%7B%20takeScreenshot%20%7D%20%3D%20require(%22.%2FtakeScreenshot.js%22)%3B%0A%0A%2F%2F%20This%20is%20the%20handler%20function%0A%2F%2F%20gets%20called%20when%20you%20hit%20the%20API%20endpoint%0Aexports.handler%20%3D%20async%20(event%2C%20context%2C%20callback)%20%3D%3E%20%7B%0A%20%20%20%20%2F%2F%20Instantiate%20a%20Chrome%20browser%0A%20%20%20%20context.callbackWaitsForEmptyEventLoop%20%3D%20false%3B%0A%20%20%20%20const%20chrome%20%3D%20await%20getChrome()%3B%0A%0A%09%09%2F%2F%20connect%20to%20the%20browser%20via%20a%20websocket%20using%20Puppeteer%0A%20%20%20%20const%20browser%20%3D%20await%20puppeteer.connect(%7B%0A%20%20%20%20%20%20%20%20browserWSEndpoint%3A%20chrome.endpoint%0A%20%20%20%20%7D)%3B%0A%0A%09%09%2F%2F%20CORS%20headers%20so%20we%20can%20make%20cross%20domain%20requests%20to%20our%20Lambda%0A%20%20%20%20const%20headers%20%3D%20%7B%0A%20%20%20%20%20%20%20%20%22Access-Control-Allow-Origin%22%3A%20%22*%22%2C%0A%20%20%20%20%20%20%20%20%22Access-Control-Allow-Credentials%22%3A%20true%2C%0A%20%20%20%20%20%20%20%20%22access-control-allow-methods%22%3A%20%22GET%22%0A%20%20%20%20%7D%3B%0A%0A%09%09%2F%2F%20Bail%20out%20if%20there's%20no%20params%0A%20%20%20%20if%20(!event.queryStringParameters)%20%7B%0A%20%20%20%20%20%20%20%20callback(null%2C%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20statusCode%3A%20400%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20headers%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20body%3A%20%22You%20need%20a%20url%22%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%7D%0A%0A%09%09%2F%2F%20Get%20the%20target%20URL%20from%20params%0A%20%20%20%20const%20targetUrl%20%3D%20event.queryStringParameters.url%3B%0A%0A%09%09%2F%2F%20Bail%20out%20if%20there's%20no%20URL%0A%20%20%20%20if%20(!targetUrl)%20%7B%0A%20%20%20%20%20%20%20%20callback(null%2C%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20statusCode%3A%20400%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20headers%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20body%3A%20%22You%20need%20something%20to%20do%22%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%7D%0A%0A%09%09%2F%2F%20Take%20screenshot%2C%20return%20result%0A%20%20%20%20try%20%7B%0A%20%20%20%20%20%20%20%20let%20result%20%3D%20await%20takeScreenshot(browser%2C%20targetUrl)%3B%0A%20%20%20%20%20%20%20%20%0A%20%20%20%20%20%20%20%20callback(null%2C%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20statusCode%3A%20200%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20headers%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20body%3A%20result%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%7D%20catch%20(e)%20%7B%0A%20%20%20%20%20%20%20%20callback(e)%3B%0A%20%20%20%20%7D%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "694px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "174.88789237668163%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'699\\'%20viewBox=\\'0%200%20400%20699\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2030c-2%203-1%20640%200%20641%202%202%20360%202%20362%200%201-1%202-638%200-641-1-3-361-3-362%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5784d82050ed365606e9bb86d107df80/ca0a1/techletter.app-screenshot-1555000349713.webp 223w", "/static/5784d82050ed365606e9bb86d107df80/75680/techletter.app-screenshot-1555000349713.webp 445w", "/static/5784d82050ed365606e9bb86d107df80/181fb/techletter.app-screenshot-1555000349713.webp 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5784d82050ed365606e9bb86d107df80/e92b6/techletter.app-screenshot-1555000349713.png 223w", "/static/5784d82050ed365606e9bb86d107df80/e66bf/techletter.app-screenshot-1555000349713.png 445w", "/static/5784d82050ed365606e9bb86d107df80/31198/techletter.app-screenshot-1555000349713.png 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5784d82050ed365606e9bb86d107df80/31198/techletter.app-screenshot-1555000349713.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Check the comments above to understand the code. Easier that way :)`}</p>
    <p>{`So we've got our `}<inlineCode parentName="p">{`handler`}</inlineCode>{`. Let's create the other files.`}</p>
    <h2 {...{
      "id": "getchromejs"
    }}>{`getChrome.js`}</h2>
    <p>{`I borrowed getChrome from `}<a parentName="p" {...{
        "href": "https://nadeesha.github.io/headless-chrome-puppeteer-lambda-servelerless/"
      }}>{`another guide`}</a>{`. Good guide but some details didn't work out for me and lead me straight to a sea of GitHub issues.`}</p>
    <p><inlineCode parentName="p">{`getChrome`}</inlineCode>{` makes sure to launch Chrome and return an instance of the browser we can use.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20launchChrome%20%3D%20require(%22%40serverless-chrome%2Flambda%22)%3B%0Aconst%20request%20%3D%20require(%22superagent%22)%3B%0A%0Aconst%20getChrome%20%3D%20async%20()%20%3D%3E%20%7B%0A%20%20%20%20const%20chrome%20%3D%20await%20launchChrome()%3B%0A%0A%20%20%20%20const%20response%20%3D%20await%20request%0A%20%20%20%20%20%20%20%20.get(%60%24%7Bchrome.url%7D%2Fjson%2Fversion%60)%0A%20%20%20%20%20%20%20%20.set(%22Content-Type%22%2C%20%22application%2Fjson%22)%3B%0A%0A%20%20%20%20const%20endpoint%20%3D%20response.body.webSocketDebuggerUrl%3B%0A%0A%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20endpoint%2C%0A%20%20%20%20%20%20%20%20instance%3A%20chrome%0A%20%20%20%20%7D%3B%0A%7D%3B%0A%0Amodule.exports%20%3D%20getChrome%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "566px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "90.13452914798206%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'361\\'%20viewBox=\\'0%200%20400%20361\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2036a7618%207618%200%20001%20291h352a7618%207618%200%20001-291c-1-3-353-3-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/94ad618d3861e19d0dace6d6fdd46236/ca0a1/techletter.app-screenshot-1555000349572.webp 223w", "/static/94ad618d3861e19d0dace6d6fdd46236/75680/techletter.app-screenshot-1555000349572.webp 445w", "/static/94ad618d3861e19d0dace6d6fdd46236/3161c/techletter.app-screenshot-1555000349572.webp 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/94ad618d3861e19d0dace6d6fdd46236/e92b6/techletter.app-screenshot-1555000349572.png 223w", "/static/94ad618d3861e19d0dace6d6fdd46236/e66bf/techletter.app-screenshot-1555000349572.png 445w", "/static/94ad618d3861e19d0dace6d6fdd46236/6fe44/techletter.app-screenshot-1555000349572.png 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/94ad618d3861e19d0dace6d6fdd46236/6fe44/techletter.app-screenshot-1555000349572.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Ask `}<inlineCode parentName="p">{`@serverless-chrome/lambda`}</inlineCode>{` to run the browser and use superagent to get its webSocket URL. We use it in the next step above to connect with Puppeteer.`}</p>
    <p>{`Great, that's our browser. Nothing packaged into our Lambda making it fat. Wonderful.`}</p>
    <h2 {...{
      "id": "takescreenshotjs"
    }}>{`takeScreenshot.js`}</h2>
    <p>{`Now the fun stuff, taking a screenshot. I'm gonna explain the code in comments so it's easier to follow 🤓`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20URL%20%3D%20require(%22url%22)%3B%0Aconst%20%7B%20uploadScreenshot%20%7D%20%3D%20require(%22.%2FuploadScreenshot%22)%3B%0A%0A%2F%2F%20Async%20takeScreenshot%20function.%20%0A%2F%2F%20Takes%20a%20browser%20instance%20and%20a%20targetUrl%0A%2F%2F%20Returns%20image%20URL%20uploaded%20to%20S3%0Aexports.takeScreenshot%20%3D%20async%20(browser%2C%20targetUrl)%20%3D%3E%20%7B%0A%09%09%2F%2F%20Open%20a%20new%20browser%20page%0A%20%20%20%20const%20page%20%3D%20await%20browser.newPage()%3B%0A%20%20%20%20%2F%2F%20Set%20browser%20size%20to%20something%20decent%2C%20mobile%20mode%20often%20tricks%20websites%20into%20loading%20faster%0A%20%20%20%20await%20page.setViewport(%7B%0A%20%20%20%20%20%20%20%20width%3A%201920%2C%0A%20%20%20%20%20%20%20%20height%3A%201080%2C%0A%20%20%20%20%20%20%20%20isMobile%3A%20true%0A%20%20%20%20%7D)%3B%0A%09%09%0A%09%09%2F%2F%20navigate%20to%20targetUrl%20page%0A%09%09%2F%2F%20wait%20for%20the%20page%20to%20load%20and%20stop%20making%20requests%0A%09%09%2F%2F%20The%20latter%20is%20important%20for%20modern%20SPAs%20that%20render%20after%20document%20is%20loaded%0A%20%20%20%20await%20page.goto(targetUrl%2C%20%7B%0A%20%20%20%20%20%20%20%20waitUntil%3A%20%5B%22domcontentloaded%22%2C%20%22networkidle2%22%5D%0A%20%20%20%20%7D)%3B%0A%0A%0A%20%20%20%20let%20element%20%3D%20null%3B%0A%0A%09%09%2F%2F%20Get%20the%20exact%20DOM%20node%20we%20want%20to%20screenshot%0A%09%09%2F%2F%20This%20is%20where%20you%20can%20keep%20adding%20any%20website%20you%20want%20%3A)%0A%20%20%20%20switch%20(URL.parse(await%20page.url()).hostname)%20%7B%0A%20%20%20%20%20%20%20%20case%20%22www.instagram.com%22%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20element%20%3D%20await%20page.%24(%22article%22)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20break%3B%0A%20%20%20%20%7D%0A%0A%09%09%2F%2F%20Get%20the%20element's%20dimensions%0A%20%20%20%20const%20%7B%20x%2C%20y%2C%20width%2C%20height%20%7D%20%3D%20await%20element.boundingBox()%3B%0A%0A%09%09%2F%2F%20construct%20a%20new%20filename%0A%20%20%20%20const%20imagePath%20%3D%20%60%2Ftmp%2Fscreenshot-%24%7Bnew%20Date().getTime()%7D.png%60%3B%0A%0A%09%09%2F%2F%20Ask%20Puppeteer%20to%20take%20a%20screenshot%20%0A%09%09%2F%2F%20save%20it%20to%20imagePath%0A%20%20%20%20await%20page.screenshot(%7B%0A%20%20%20%20%20%20%20%20path%3A%20imagePath%2C%0A%20%20%20%20%20%20%20%20clip%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20x%3A%20x%20%2B%202%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20y%3A%20y%20%2B%202%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20width%3A%20width%20-%202%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20height%3A%20height%20-%202%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D)%3B%0A%0A%09%09%2F%2F%20upload%20screenshot%20to%20S3%0A%20%20%20%20const%20url%20%3D%20await%20uploadScreenshot(imagePath)%3B%0A%0A%09%09%2F%2F%20return%20the%20result%0A%20%20%20%20return%20url%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "886px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "136.77130044843048%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'548\\'%20viewBox=\\'0%200%20400%20548\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M15%2024c-2%203-1%20501%200%20502%202%202%20368%202%20370%200%201-1%202-499%200-502-1-3-369-3-370%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0e5f34fecd04f01a4bebcb45fac70629/ca0a1/techletter.app-screenshot-1555000349902.webp 223w", "/static/0e5f34fecd04f01a4bebcb45fac70629/75680/techletter.app-screenshot-1555000349902.webp 445w", "/static/0e5f34fecd04f01a4bebcb45fac70629/b4685/techletter.app-screenshot-1555000349902.webp 886w"],
                "sizes": "(max-width: 886px) 100vw, 886px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0e5f34fecd04f01a4bebcb45fac70629/e92b6/techletter.app-screenshot-1555000349902.png 223w", "/static/0e5f34fecd04f01a4bebcb45fac70629/e66bf/techletter.app-screenshot-1555000349902.png 445w", "/static/0e5f34fecd04f01a4bebcb45fac70629/cc155/techletter.app-screenshot-1555000349902.png 886w"],
                "sizes": "(max-width: 886px) 100vw, 886px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0e5f34fecd04f01a4bebcb45fac70629/cc155/techletter.app-screenshot-1555000349902.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`In a nutshell, our `}<inlineCode parentName="p">{`takeScreenshot`}</inlineCode>{` function opens a new browser page, navigates to a specific URL, looks for the exact DOM node we want to screenshot, uploads to S3, and returns the result.`}</p>
    <p>{`I used to try closing the page after screenshotting but that seems to hang sometimes for some websites. Causes problems so it's best to avoid.`}</p>
    <p>{`Lambdas kill their execution environment, and the browser, after running anyway. Shouldn't be any harm in keeping pages open.`}</p>
    <p>{`As you can see I wrote this code so it's easy to add other websites. ✌️`}</p>
    <h2 {...{
      "id": "uploadscreenshotjs"
    }}>{`uploadScreenshot.js`}</h2>
    <p>{`Last step in the puzzle is uploading our screenshot to S3. You can't host from temporary Lambda files. Gotta put it somewhere permanent.`}</p>
    <p>{`Again, I'll explain the code inline. Think that's a good approach.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20aws%20%3D%20require(%22aws-sdk%22)%3B%0Aconst%20gm%20%3D%20require(%22gm%22).subClass(%7B%0A%20%20%20%20imageMagick%3A%20true%0A%7D)%3B%0Aconst%20fs%20%3D%20require(%22fs%22)%3B%0A%0A%2F%2F%20Your%20S3%20bucket%20from%20earlier.%20Make%20sure%20you%20use%20the%20same%20name%0Aconst%20BUCKET%20%3D%20%22techletter.app%22%3B%0A%0A%2F%2F%20uploadScreenshot%20takes%20a%20temporary%20file%20path%20and%20returns%20a%20URL%0Aexports.uploadScreenshot%20%3D%20async%20function%20uploadScreenshot(%0A%20%20%20%20path%2C%0A%20%20%20%20resize%20%3D%20true%0A)%20%7B%0A%09%09%2F%2F%20aws-sdk%20is%20all%20callback-based%20so%20we%20have%20to%20wrap%20in%20Promises%2C%20yuck%0A%20%20%20%20return%20new%20Promise((resolve%2C%20reject)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20const%20s3%20%3D%20new%20aws.S3(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20apiVersion%3A%20%222006-03-01%22%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%0A%20%20%20%20%20%20%20%20if%20(resize)%20%7B%0A%09%09%20%20%20%20%20%20%20%20%2F%2F%20We%20use%20ImageMagick%20to%20resize%20files%20to%20640px%20width%0A%09%09%20%20%20%20%20%20%20%20%2F%2F%20Smaller%20files%20open%20faster%20and%20use%20less%20space%0A%09%09%20%20%20%20%20%20%20%20%2F%2F%20Still%20look%20sharp%20enough%20%3A)%0A%20%20%20%20%20%20%20%20%20%20%20%20gm(path)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.resize(640)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20make%20sure%20we%20save%20as%20png%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.toBuffer(%22png%22%2C%20async%20function(err%2C%20buffer)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20if%20(err)%20reject(err)%3B%0A%0A%09%09%09%09%09%09%09%09%09%09%2F%2F%20this%20is%20the%20part%20that%20actually%20uploads%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20const%20%7B%20Location%20%7D%20%3D%20await%20s3%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.upload(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Bucket%3A%20BUCKET%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Key%3A%20%60screenshot-%24%7Bnew%20Date().getTime()%7D.png%60%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Body%3A%20buffer%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20ACL%3A%20%22public-read%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.promise()%3B%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20resolve(Location)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%7D%20else%20%7B%0A%09%09%09%09%20%20%20%20%2F%2F%20when%20not%20resizing%20we%20just%20read%20the%20file%20and%20upload%0A%20%20%20%20%20%20%20%20%20%20%20%20(async%20function()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20const%20buffer%20%3D%20await%20new%20Promise((resolve%2C%20reject)%20%3D%3E%20%7B%0A%09%09%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20reading%20the%20file%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20fs.readFile(path%2C%20(err%2C%20data)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20if%20(err)%20reject(err)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20resolve(data)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%0A%09%09%09%09%09%09%09%09%2F%2F%20uploading%20the%20file%20buffer%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20const%20%7B%20Location%20%7D%20%3D%20await%20s3%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.upload(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Bucket%3A%20BUCKET%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Key%3A%20%60screenshot-%24%7Bnew%20Date().getTime()%7D.png%60%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Body%3A%20buffer%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20ACL%3A%20%22public-read%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.promise()%3B%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20resolve(Location)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)()%3B%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "750px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "185.65022421524665%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'743\\'%20viewBox=\\'0%200%20400%20743\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M17%2027v346l1%20345h365V27l-183-1-183%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/55859e4339f61f65043da90e8ac3bf45/ca0a1/techletter.app-screenshot-1555000349538.webp 223w", "/static/55859e4339f61f65043da90e8ac3bf45/75680/techletter.app-screenshot-1555000349538.webp 445w", "/static/55859e4339f61f65043da90e8ac3bf45/08b4d/techletter.app-screenshot-1555000349538.webp 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/55859e4339f61f65043da90e8ac3bf45/e92b6/techletter.app-screenshot-1555000349538.png 223w", "/static/55859e4339f61f65043da90e8ac3bf45/e66bf/techletter.app-screenshot-1555000349538.png 445w", "/static/55859e4339f61f65043da90e8ac3bf45/1d69c/techletter.app-screenshot-1555000349538.png 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/55859e4339f61f65043da90e8ac3bf45/1d69c/techletter.app-screenshot-1555000349538.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We should now have everything in place to use our Instagram screenshot service.`}</p>
    <h2 {...{
      "id": "the-very-important-hack"
    }}>{`The very important hack`}</h2>
    <p>{`This is a hack. It's ugly. I found it `}<a parentName="p" {...{
        "href": "https://github.com/adieuadieu/serverless-chrome/issues/92"
      }}>{`in GitHub issues`}</a>{`. Fixes the "socket hang up" error with Chrome.`}</p>
    <p>{`Go into your `}<inlineCode parentName="p">{`node_modules/@serverless-chrome/lambda/dist/bundle.*`}</inlineCode>{` files. There's two of them.`}</p>
    <p>{`In each of those files look for a line like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20LOGGING_FLAGS%20%3D%20process.env.DEBUG%20%3F%20%5B'--enable-logging'%2C%20'--log-level%3D0'%2C%20'--v%3D99'%5D%20%3A%20%5B%5D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "862px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "21.524663677130047%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'87\\'%20viewBox=\\'0%200%20400%2087\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M16%2023l-1%2021%201%2021h369V44l-1-21H16\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bad14da04fee6e4feaa3ce47f6dfc309/ca0a1/techletter.app-screenshot-1555000347282.webp 223w", "/static/bad14da04fee6e4feaa3ce47f6dfc309/75680/techletter.app-screenshot-1555000347282.webp 445w", "/static/bad14da04fee6e4feaa3ce47f6dfc309/e32b8/techletter.app-screenshot-1555000347282.webp 862w"],
                "sizes": "(max-width: 862px) 100vw, 862px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bad14da04fee6e4feaa3ce47f6dfc309/e92b6/techletter.app-screenshot-1555000347282.png 223w", "/static/bad14da04fee6e4feaa3ce47f6dfc309/e66bf/techletter.app-screenshot-1555000347282.png 445w", "/static/bad14da04fee6e4feaa3ce47f6dfc309/f0551/techletter.app-screenshot-1555000347282.png 862w"],
                "sizes": "(max-width: 862px) 100vw, 862px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bad14da04fee6e4feaa3ce47f6dfc309/f0551/techletter.app-screenshot-1555000347282.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Remove the `}<inlineCode parentName="p">{`--v=99`}</inlineCode>{` part`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20LOGGING_FLAGS%20%3D%20process.env.DEBUG%20%3F%20%5B'--enable-logging'%2C%20'--log-level%3D0'%5D%20%3A%20%5B%5D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "782px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "23.76681614349776%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'96\\'%20viewBox=\\'0%200%20400%2096\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M17%2027c-2%203-1%2043%200%2044%202%202%20364%202%20366%200%201-1%202-41%200-44-1-3-365-3-366%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/07d2fa0c44297ea67ca65f92da811176/ca0a1/techletter.app-screenshot-1555000349407.webp 223w", "/static/07d2fa0c44297ea67ca65f92da811176/75680/techletter.app-screenshot-1555000349407.webp 445w", "/static/07d2fa0c44297ea67ca65f92da811176/c0b7e/techletter.app-screenshot-1555000349407.webp 782w"],
                "sizes": "(max-width: 782px) 100vw, 782px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/07d2fa0c44297ea67ca65f92da811176/e92b6/techletter.app-screenshot-1555000349407.png 223w", "/static/07d2fa0c44297ea67ca65f92da811176/e66bf/techletter.app-screenshot-1555000349407.png 445w", "/static/07d2fa0c44297ea67ca65f92da811176/2e195/techletter.app-screenshot-1555000349407.png 782w"],
                "sizes": "(max-width: 782px) 100vw, 782px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/07d2fa0c44297ea67ca65f92da811176/2e195/techletter.app-screenshot-1555000349407.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><strong parentName="p"><em parentName="strong">{`You have to do this every time you run Yarn or reinstall anything for any reason`}</em></strong></p>
    <p>{`Yes it sucks. Yes I should make an upstream PR. But doing it yourself unblocks you and makes your Lambda work `}<em parentName="p">{`right now.`}</em></p>
    <p>{`I have no idea why that breaks it.`}</p>
    <p>{`Another option might be to remove the `}<inlineCode parentName="p">{`DEBUG`}</inlineCode>{` flag in your serverless.yml ... but then how will you debug?`}</p>
    <h2 {...{
      "id": "and-deploy-"
    }}>{`And, deploy :)`}</h2>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%24%20sls%20deploy"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "198px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "94.44444444444444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'378\\'%20viewBox=\\'0%200%20400%20378\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M75%2098l-5%201c-5%203-5%200-5%2092%200%2095%200%2088%207%2091%205%203%20252%203%20257%200%207-3%207%204%207-91%200-90%200-88-5-92a9475%209475%200%2000-257-2m67%2034c-7%206-6%2015%201%2019%2012%207%2024-10%2013-19-4-4-10-4-14%200m41%200c-9%206-4%2020%207%2020%204%200%2010-5%2010-9%202-9-9-17-17-11m-77%2079l-3%203c-3%203-2%207%201%209%204%202%204%206%200%206-3-1-4%201%200%202l2%203c0%202%202%202%203%200l3-4c3-3%202-7-2-8-3-1-2-5%201-6l3-1-3-1-2-2-1-2-2%201m101%202c0%203%200%204-3%203-4%200-7%203-7%208s6%2011%209%207h1c3%202%203%200%203-11l-1-10c-2%200-2%201-2%203m9%205c-6%206-1%2015%207%2014l3-2-3-1c-3%201-7-1-7-4l5-1c6%200%207-2%205-6-2-3-8-3-10%200m14%209l1%2011%202-3c0-2%201-3%203-3%204%200%206-2%207-7%201-6-2-9-8-9h-5v11m34-9c-6%208%202%2018%209%2012%205-5%202-14-4-14-3%200-4%201-5%202m14-1l1%202%204%2013-2%203-2%202c0%202%204%201%205%200l8-21c-2-1-4%201-5%206-2%206-2%206-5-1-1-5-4-7-4-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cfaa80300bf73b03373264fb4c1f4267/1ec35/techletter.app-screenshot-1555000349732.webp 198w"],
                "sizes": "(max-width: 198px) 100vw, 198px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cfaa80300bf73b03373264fb4c1f4267/18f77/techletter.app-screenshot-1555000349732.png 198w"],
                "sizes": "(max-width: 198px) 100vw, 198px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cfaa80300bf73b03373264fb4c1f4267/18f77/techletter.app-screenshot-1555000349732.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Serverless packages your lambda, deploys to AWS, sets everything up for you, and returns a URL.`}</p>
    <p>{`That URL is your API endpoint. Call it with an Instagram URL and behold your wonderful screenshots.`}</p>
    <p><img parentName="p" {...{
        "src": "/235fd413355c36c0ae89a90dfcf15c6b/kAJYl73.gif",
        "alt": null
      }}></img></p>
    <p>{`I wrapped mine in a nice UI. You can try it at `}<a parentName="p" {...{
        "href": "https://techletter.app"
      }}>{`TechLetter.App`}</a></p>
    <p>{`PS: I'm working on new education materials, workshops, course and such for serverless, lambdas, full stack React, GraphQL, and Gatsby. Hit reply if you're interested or `}<a parentName="p" {...{
        "href": "https://twitter.com/swizec"
      }}>{`ping me on Twitter`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      